/**
* @ngdoc service
* @name tcApp.service:shortcutkeyService
* @description
* Shortcut Key Service. Handles shortcuts arrays, key tips and shortcut execution
*/

angular.module('tc.shortcutkey')
.value('tcShortcutkeyTipPositions', {
	'default': {
		left: -10,
		top: -10
	},
	'left': {
		left: 0,
		top: 10
	},
})
.service('shortcutkeyService', function($window, $document, $timeout, $log, $mdSidenav,
										tcShortcutkeyFilter, tcShortcutkeyTipPositions, tcConstants, tcStickyheaderOptions,
										GlobalService) {
	var $this = this;
	this.mode = null;
	this.modeElements = [];
	this.keyTipHandler = null;
	
	// Firefox & IE11 do not handle Alt keyup correctly
	// e.g. Test events for Alt-* at http://www.quirksmode.org/js/keys.html
	var isFirefox = ($window.navigator.userAgent.indexOf('Firefox') !== -1);
	var isIE11 = (!!$window.MSInputMethodContext && !!$window.document.documentMode);
	
	// Map of shortcut key codes to arrays of element ids, grouped by container
	this.shortcuts = {
		'.mainScreen': {},
		'tc-main-menu': {},
		'tc-action-menu': {},
		'.tcOverlay': {}
	};
	
	this.addKey = function(key, elementId) {
		if (!key) return;
		if ((!elementId) || (elementId === '')) {
			$log.warn('Shortcut Key: Element must have id attribute', key);
			return;
		}
		// Key the element based on which container it is in
		var containerElement = getContainerElement(elementId);
		if (!containerElement) return;
		key = tcShortcutkeyFilter(key);
		if (key === null) return;
		if (angular.isUndefined($this.shortcuts[containerElement][key])) $this.shortcuts[containerElement][key] = [];
		if ($this.shortcuts[containerElement][key].length === 9) {
			// Limitation - only 9 elements can be bound to the same key for multi mode
			// This is because multimode can fire child mode, which requires Alt keyup to execute
			//$log.warn('Shortcut key ', key, ' cannot be bound to more than 9 elements: ', elementId);
		} else {
			$this.shortcuts[containerElement][key].push(elementId);
		}
	};
	
	this.removeKey = function(key, elementId) {
		if (!key) return;
		if ((!elementId) || (elementId === '')) {
			$log.warn('Shortcut Key: Element must have id attribute, for key:', key);
			return;
		}
		var containerElement = getContainerElement(elementId);
		if (!containerElement) return;
		if (angular.isUndefined(this.shortcuts[containerElement][key])) {
			// Some shortcuts are removed prior to the element being destroyed, e.g. for overlays
			return;
		}
		this.shortcuts[containerElement][key] = this.shortcuts[containerElement][key].filter(function(item) {
			return (item !== elementId);
		});
	};
	
	this.removeKeysForContainer = function(containerElement) {
		this.shortcuts[containerElement] = {};
	};

	// Adds the keytip element when applicable. Returns true if the element can be clicked
	this.showKeyTip = function(appendToElement, keyTipText, parentKey) {
		keyTipText = tcShortcutkeyFilter(keyTipText, parentKey);
		if (keyTipText === null) return false;
		if (appendToElement[0]) {
			if (!GlobalService.isElementVisible(appendToElement[0])) {
				// Where element is hidden, don't show tip but allow click where there attribute exists
				return (appendToElement[0].getAttribute('tc-shortcutkey-allowhidden') !== null);
			}
			if (!GlobalService.isElementInView(appendToElement[0])) {
				var appendToClone = null;
				if (appendToElement[0].tagName === 'TABLE') {
					// Special logic for table sticky header... append to the cloned THEAD
					appendToClone = $window.document.getElementById(appendToElement[0].id + tcStickyheaderOptions.CLONE_ID);
					if (appendToClone) appendToElement[0] = appendToClone;
				}
				if (!appendToClone) {
					// Where element is out of view, don't show tip but allow click where there attribute exists
					return (appendToElement[0].getAttribute('tc-shortcutkey-allowoutofview') !== null);
				}
			}
		}
		
		if (tcConstants.KEY_HTMLCODE[keyTipText]) keyTipText = tcConstants.KEY_HTMLCODE[keyTipText];
		
		var bodyElement = angular.element($window.document.body);
		bodyElement.append('<tc-shortcutkey-tip id="tc_KeyTip-' +
							appendToElement[0].id + '">' + keyTipText + '</tc-shortcutkey-tip>');
		var keyTipPosition = (
							((appendToElement[0].tagName === 'LI') || (appendToElement[0].tagName === 'TR')) ? 'left'
							: 'default');
		var positionTop = (appendToElement[0].getBoundingClientRect().top +
							tcShortcutkeyTipPositions[keyTipPosition].top);
		var	positionLeft = (appendToElement[0].getBoundingClientRect().left +
							tcShortcutkeyTipPositions[keyTipPosition].left);
		positionTop = (positionTop < 0 ? 0 : positionTop);
		positionLeft = (positionLeft < 0 ? 0 : positionLeft);
		var keyTipElement = bodyElement[0].lastChild;
		angular.element(keyTipElement).css({
			top: (positionTop + 'px'),
			left: (positionLeft + 'px')
		});
		return true;
	};
	
	this.showAllKeyTips = function($event) { // eslint-disable-line
		angular.forEach($this.shortcuts, function(container) {
			angular.forEach(container, function(elements, key) {
				angular.forEach(elements, function(elementId) {
					var element = $window.document.getElementById(elementId);
					if (element) {
						element = angular.element(element);
						if (isShortcutKeyAllowed(element[0])) {
							$this.showKeyTip(element, key);
						}
					}
				});
			});
		});
		if ($this.keyTipHandler) $timeout.cancel($this.keyTipHandler);
	};
	
	this.hideAllKeyTips = function($event) { // eslint-disable-line
		var keytips = $window.document.querySelectorAll('tc-shortcutkey-tip');
		angular.forEach(keytips, function(element) {
			element.parentNode.removeChild(element); // IE11.... !@^&%~!^&#
		});
		if ($this.keyTipHandler) {
			$timeout.cancel($this.keyTipHandler);
			$this.keyTipHandler = null;
		}
	};
	
	var getContainerElement = function(elementId) {
		var element = $window.document.getElementById(elementId);
		var mainMenuElement = $window.document.querySelector('tc-main-menu');
		var actionMenuElement = $window.document.querySelector('tc-action-menu');
		
		if (mainMenuElement.contains(element)) {
			return 'tc-main-menu';
		} else if (actionMenuElement.contains(element)) {
			return 'tc-action-menu';
		} else {
			var overlayElement = $window.document.querySelector('.tcOverlay');
			if ((overlayElement) && (overlayElement.querySelector('#' + elementId))) {
				return '.tcOverlay';
			}
		}
		return '.mainScreen';
	};
	
	var isShortcutKeyAllowed = function(element) {
		if (element.id === '') return false;
		if ((element.tagName === 'A') && element.getAttribute('disabled')) return false;
		
		// When sidenav is open, only show shortcut keys for elements that are children of the sidenav
		if ($mdSidenav('mainMenu').isOpen()) {
			if (!$window.document.querySelector('tc-main-menu').querySelector('#' + element.id)) {
				return false;
			}
		} else if ($mdSidenav('actionMenu').isOpen()) {
			if (!$window.document.querySelector('tc-action-menu').querySelector('#' + element.id)) {
				return false;
			}
		} else {
			// If sidenav is closed, hide any keytips for sidenav elements
			if ($window.document.querySelector('md-sidenav').querySelector('#' + element.id)) {
				return false;
			}
		}
		var overlayElement = $window.document.querySelector('.tcOverlay');
		if (overlayElement) {
			if (!overlayElement.querySelector('#' + element.id)) {
				return false;
			}
		}
		return true;
	};
	
	// Checks whether the element has any shortcut key children
	// If so, switches to child mode and shows children key tips
	var switchToChildMode = function(element, key) {
		// Gets an array of child elements where the attribute 'tc-shortcutkey-childof' equals the key
		var childElements = element.querySelectorAll('[tc-shortcutkey-childof="' + key + '"]');
		// Convert NodeList to an array
		childElements = Array.prototype.slice.call(childElements);
		// Remove all hidden child nodes
		childElements = childElements.filter(function(child) {
			if ((child.getAttribute('tc-shortcutkey-allowhidden') === null)
				&& (!GlobalService.isElementVisible(child))) {
				return false;
			}
			if ((child.getAttribute('tc-shortcutkey-allowoutofview') === null)
				&& (!GlobalService.isElementInView(child))) {
				return false;
			}
			return true;
		});
		if (childElements.length > 0) {
			$this.hideAllKeyTips();
			// Switch to child mode, all further keys are handled by childModeHandler
			$this.mode = 'child';
			$this.modeElements = [];
			angular.forEach(childElements, function(child, childIndex) {
				// Show the key tips for all child elements that have 'tc-shortcutkey-childof' set
				if (!child.getAttribute('disabled')) {
					// Only add elements that can be assigned a keytip
					if (!$this.showKeyTip(angular.element(child), (childIndex + 1), key)) return;
					$this.modeElements.push(child);
				}
			});
			return true;
		}
		return false;
	};
	
	// Execute the click handler / ng-click or href of the element, if it is not disabled
	var clickElement = function(element) {
		if (!element.getAttribute('disabled')) {
			element.click();
			var forElement = element.getAttribute('for');
			if (forElement) forElement = $window.document.getElementById(forElement);
			if ((forElement) && ((forElement.tagName === 'INPUT') || (forElement.tagName === 'TEXTAREA'))) {
				forElement.select();
			}
			if ((element.tagName === 'MD-CHECKBOX') || (element.tagName === 'MD-RADIOBUTTON')) {
				element.focus();
			}
		}
		$this.hideAllKeyTips();
		disableMode();
	};
	
	var shortcutKeyDownHandler = function($event) {
		if (!$event.altKey) {
			// Firefox/IE11 do not handle Alt keyup after pressing subsequent key
			// So hide keytips on any further keydown
			// FF = https://bugzilla.mozilla.org/show_bug.cgi?id=1335347
			if ((isFirefox || isIE11) && ($this.mode !== null)) {
				$this.hideAllKeyTips($event);
				disableMode();
			}
			return;
		}
		if ([tcConstants.KEY_CODE.LEFT_ARROW, tcConstants.KEY_CODE.TAB,
			tcConstants.KEY_CODE.RIGHT_ARROW].indexOf($event.keyCode) !== -1) {
			// Allow default browser shortcuts for Alt-left/right/tab
			$this.hideAllKeyTips($event);
			return;
		}
		if ((isFirefox || isIE11) && ($event.keyCode === tcConstants.KEY_CODE.ALT) && ($this.mode !== null)) {
			// See above note for Firefox/IE11
			$this.hideAllKeyTips($event);
			disableMode();
		}
		var key = getKeyFromEvent($event);
		var containerElement = ($mdSidenav('mainMenu').isOpen() ? 'tc-main-menu'
								: $mdSidenav('actionMenu').isOpen() ? 'tc-action-menu'
								: $window.document.querySelector('.tcOverlay') ? '.tcOverlay'
								: '.mainScreen');
					
		if ($event.keyCode === tcConstants.KEY_CODE.ALT) {
			$event.preventDefault();
			$event.stopPropagation();
			if (!$this.keyTipHandler) {
				// First time Alt is pressed, show all key tips after a delay
				$this.keyTipHandler = $timeout($this.showAllKeyTips, 500, false, $event);
			}
		} else if ($this.mode === 'child') {
			$event.preventDefault();
			childModeHandler($event);
		} else if ($this.mode === 'multi') {
			$event.preventDefault();
			multiModeHandler($event);
		} else if (angular.isDefined($this.shortcuts[containerElement][key])) {
			// Change the value of any currently focused field
			if ($event.target) $event.target.blur();
			$event.preventDefault();
			$event.stopPropagation();
			
			var keyElements = $this.shortcuts[containerElement][key];
			// Filter out any hidden elements before determining the mode
			keyElements = keyElements.filter(function(elementId) {
				var element = $window.document.getElementById(elementId);
				if (!element) return false;
				if ((element.getAttribute('tc-shortcutkey-allowhidden') === null)
					&& (!GlobalService.isElementVisible(element))) return false;
				if ((element.getAttribute('tc-shortcutkey-allowoutofview') === null)
					&& (!GlobalService.isElementInView(element))) return false;
				return true;
			});
			
			// Only one element is bound to the shortcut key
			if (keyElements.length === 1) {
				var elementId = keyElements[0];
				var element = $window.document.getElementById(elementId);
				if ((element) && (isShortcutKeyAllowed(element))) {
					$this.hideAllKeyTips($event);
					var inChildMode = switchToChildMode(element, key);
					if (!inChildMode) {
						clickElement(element);
					}
				} else {
					$log.warn('Shortcut key could not find element: ', elementId);
				}
			} else if (keyElements.length > 1) {
				$this.hideAllKeyTips($event);
				$this.mode = 'multi';
				// Show numbers where more than one element is bound to the shortcut key
				var visibleElementIndex = 0;
				angular.forEach(keyElements, function(elementId) {
					var element = $window.document.getElementById(elementId);
					if ((element) && (isShortcutKeyAllowed(element))) {
						// Only add elements that can be assigned a keytip
						if (!$this.showKeyTip(angular.element(element), ++visibleElementIndex)) return;
						$this.modeElements.push(element);
					}
				});
			}
		}
	};
	
	var shortcutKeyUpHandler = function($event) {
		if ($event.keyCode !== tcConstants.KEY_CODE.ALT) {
			return;
		}
		$this.hideAllKeyTips($event);
		disableMode();
	};
	
	var windowBlurHandler = function() {
		$this.hideAllKeyTips();
		disableMode();
	};
	
	var bodyScrollHandler = function() {
		$this.hideAllKeyTips();
		disableMode();
	};
	
	var disableMode = function() {
		$this.mode = null;
		$this.modeElements = [];
	};
	
	// Handles the numeric shortcut keys for children of a shortcut key
	var childModeHandler = function($event) {
		var handlerFound = false;
		var key = getKeyFromEvent($event);
		angular.forEach($this.modeElements, function(child, childIndex) {
			if (handlerFound) return;
			if (key === tcShortcutkeyFilter(childIndex + 1)) {
				// Allow more than one level of child mode
				if (switchToChildMode(child, (childIndex + 1))) {
					handlerFound = true;
				} else {
					clickElement(child);
					handlerFound = true;
				}
			}
		});
	};
	
	// Handles the numeric shortcut keys for multiple elements bound to the same key
	var multiModeHandler = function($event) {
		var handlerFound = false;
		var key = getKeyFromEvent($event);
		angular.forEach($this.modeElements, function(element, elementIndex) {
			if (handlerFound) return;
			if (key === tcShortcutkeyFilter(elementIndex + 1)) {
				// Allow child mode from multi mode, get the shortcut key of the current element
				var elementKey = element.getAttribute('tc-shortcutkey');
				if ((elementKey) && (elementKey[0] === '\'')) elementKey = elementKey.substr(1, elementKey.length - 2);
				if (switchToChildMode(element, elementKey)) {
					handlerFound = true;
				} else {
					clickElement(element);
					handlerFound = true;
				}
			}
		});
	};

	var getKeyFromEvent = function($event) {
		if ($event.code) return $event.code.replace(/Key|Digit/, '').toUpperCase();
		return $event.key.replace(/^(Up|Down|Left|Right)/, 'Arrow$1').toUpperCase(); // IE is special
	};
	
	$document.bind('keydown', shortcutKeyDownHandler);
	$document.bind('keyup', shortcutKeyUpHandler);
	angular.element($window).on('blur', windowBlurHandler);
	angular.element($window.document.getElementById('tc_Home-misc-body')).on('scroll', bodyScrollHandler);
});

